/* eslint-disable */
import { useEffect } from 'react';

export function useIsUnloaded(method: VoidFunction) {
  useEffect(() => {
    return method;
  }, []);
}
